export default __webpack_public_path__ + "static/pzw rumia-68052f2b2b5ddace39b27f938c42a9dd.png";